import React from 'react';
import { BadgeCheck, Gem } from 'lucide-react';

const TIER_DOT = {
  diamond: 'bg-[#d4a853]',
  spotlight: 'bg-[#c9a54e]/80',
  rising: 'bg-white/50',
  base: 'bg-white/25',
};

export const LiveIdentityBadge = ({ session, lang, compact = false }) => {
  const tier = session?.presence_tier || 'base';
  const isShow = (session?.session_format || 'room') === 'show';
  const badges = session?.live_badges || [];

  if (compact) {
    return (
      <div className="flex items-center gap-1.5">
        <span className={`w-1.5 h-1.5 rounded-full ${TIER_DOT[tier] || TIER_DOT.base}`} />
        <span className="text-[10px] text-white/40 uppercase tracking-wider">{isShow ? 'Show' : 'Room'}</span>
      </div>
    );
  }

  return (
    <div data-testid={`live-identity-badge-${session?.id || 'host'}`} className="flex items-center gap-2">
      <span className={`w-2 h-2 rounded-full ${TIER_DOT[tier] || TIER_DOT.base}`} />
      <span className="text-[11px] text-white/50 uppercase tracking-[0.12em] font-medium">
        {isShow ? 'Show' : 'Room'}
      </span>
      {tier !== 'base' && (
        <span className="text-[10px] text-[#d4a853]/70 uppercase tracking-wider">{tier}</span>
      )}
      {badges.includes('artist') && <BadgeCheck size={12} className="text-white/40" />}
      {badges.includes('diamond') && <Gem size={11} className="text-[#d4a853]/60" />}
    </div>
  );
};
